import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { NotificationService } from 'src/app/services/push-notifications/notification.service';
import { AllNotificationsService } from 'src/app/services/notifications/all-notifications.service';
import { ConfigErrorHandler } from '../../shared/config.errorhandler';
import { Router } from '@angular/router';
import { AppNotification } from 'src/app/models/notification';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent implements OnInit{

  user_full_name: any="";
  notifications: AppNotification[] = [];
  private newNotifSub!: Subscription;
  public isLoading: boolean = false;

  get unreadCount(): number {
    return this.notifications.filter(n => !n.read).length;
  }

  constructor(
    public auth: AuthService,
    private notificationService: NotificationService,
    private allNotificationsService: AllNotificationsService,
    public handler: ConfigErrorHandler,
    private router: Router
  ) { }

  ngOnInit(): void {
     this.isLoading = true;
    this.user_full_name=localStorage.getItem('userFullName');

    this.getAllNotifications();

     // Prepend any notification that arrives while the app is open
    this.newNotifSub = this.notificationService.newNotification$.subscribe(n => {
      this.notifications.unshift(n);
    });
  }

  ngOnDestroy(): void {
    this.newNotifSub?.unsubscribe();
  }

  trackById(index: number, item: AppNotification): string|null {
    return item.txn_id;
  }

  // Roughly detect if a message needs truncation (tweak threshold as needed)
  isLong(message: string): boolean {
    return message.length > 150;
  }

  // Open notification in the global modal
  openDetails(n: AppNotification, event: Event): void {
   event.preventDefault();
    event.stopPropagation();

    n.read = true;

    // Reuse the exact same pipeline your push notifications use
    this.notificationService.triggerGlobalModal({
      title: n.title || 'Notification Alert',
      body: n.message,
      txnId: n.txn_id,
      txnType: n.txn_type,
      createdAt:n.created_at
    });
  }

  /**
   * Get all notifications
   */
  getAllNotifications(): void {
    this.allNotificationsService.getAll()
    .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.isLoading = false;
            this.notifications = response.data

          }else{
            this.isLoading = false;
          }
        },
        error: (error) => {
          this.isLoading = false;
        }
      });
  }

  // Handles clicks on the notification item itself
  onItemClick(n: AppNotification, event: Event): void {
    // Long messages: item click does nothing — only "Read more" opens the modal
    if (this.isLong(n.message)) {
      return;
    }

    event.preventDefault();
    n.read = true;
    this.navigateForNotification(n);
  }

  private navigateForNotification(n: AppNotification): void {
    const type = n.txn_type;
    const txn_id = n.txn_id;

    let url: string | null = null;

    switch (type) {
      case 'transfer':
         url = this.router.serializeUrl(
          this.router.createUrlTree(['/view-transferred-vehicle', txn_id])
        );
        break;
      case 'delivery':
        url = this.router.serializeUrl(
          this.router.createUrlTree(['/view-transferred-vehicle', txn_id])
        );
        break;

      case 'receive':
        url = this.router.serializeUrl(
          this.router.createUrlTree(['/view-received-vehicle', txn_id])
        );
        break;

      case 'unshipped_bls':
        url = this.router.serializeUrl(
          this.router.createUrlTree(['/suppliers/bl-list'])
        );
        break;

      case 'vessel_eta_update':
        url = this.router.serializeUrl(
          this.router.createUrlTree(['/update-bl', txn_id])
        );
        break;

      case 'duty':
        url = txn_id ?? '';
        break;

      default:
        // No known route for this txn_type — fall back to the modal
        this.notificationService.triggerGlobalModal({
          title: n.title || 'Notification Alert',
          body: n.message,
          txnId: n.txn_id,
          txnType: n.txn_type,
          createdAt: n.created_at
        });
        return;
    }

    window.open(url, '_blank');
  }

  logout() {
    this.auth.logout().subscribe({
      next: (response) =>console.log(response),
      error: (e) => this.handler.handleError(e),
      complete: () =>{
        localStorage.clear(); //Clear user session

        let accessToken = localStorage.removeItem('accessToken');

        if (accessToken == null ) {
          window.location.href = '/login';
        }
      }
    });
  }

  get needsNotificationPermission(): boolean {
    return 'Notification' in window && Notification.permission === 'default';
  }

  enableNotifications() {
    this.notificationService.requestPermission();
  }
}
